<div class="modal-header bg-secondary text-white font-weight-bold" style="font-size: 1.4rem">
  {{ title }}
</div>
<div class="modal-body text-center">
  <div style="font-size: 1.2rem" [innerHTML]="question"></div>
  <button
    *ngIf="yesBtnText"
    type="button"
    #yesBtn
    [ngClass]="yesBtnClass"
    [disabled]="yesProcessing || noProcessing"
    (click)="onYesButtonClicked()"
  >
    <i *ngIf="yesProcessing" class="fa fa-spinner fa-spin mr-2"></i
    >{{ yesBtnText }}
  </button>
  <button
    *ngIf="noBtnText"
    type="button"
    #noBtn
    [ngClass]="noBtnClass"
    [disabled]="yesProcessing || noProcessing"
    (click)="onNoButtonClicked()"
  >
    <i *ngIf="noProcessing" class="fa fa-spinner fa-spin mr-2"></i
    >{{ noBtnText }}
  </button>
</div>
